'use strict';

import $ from 'jquery';

import { lib } from '../../common/Library';
import { settingUpdate } from '../portfolio/setting_update.js';

/**
 * 共通モーダル
 */

$(function () {

    // メインモーダルお気に入り / 損益シミュレータに登録
    //
    // サブモーダル:お気に入りに登録
    // サブモーダル:損益シミュレータに登録

    // メインモーダル表示
    $('#save_stock').on('click', () => {
        // 値のセット(スクリーニングと決算カレンダー日別のみ)
        if (window.location.href.includes('screening') || window.location.href.includes('scheduleDay')) {
            updateAddFavSimShareClassIds();
        }

        // 値のセット(個別銘柄)
        if (window.location.href.includes('symbolDetail')) {
            updateSymbolDetailFavSimShareClassId();
        }

        // チェックが入っているもしくは表示されている行をモーダルに追加
        addMainModalList(JSON.parse($('#addFavSimShareClassIds').val()));

        // チェックボックス全選択、全解除
        lib.selectCheckAll('#modal_check_all', '.modal_check');

        // モーダル表示
        showSaveStockModal();
    });

    // ボタンクリック:サブモーダル表示
    $('#main_reg_fav').on('click', () => {
        // チェックされた銘柄があるか確認
        if (getCheckedMainStockCount() <= 0) {
            lib.jqAlert('お気に入り / 損益シミュレータへ登録', '登録する銘柄を選択してください。');
            return;
        } else {
            // お気に入りグループを取得してモーダルを表示
            const favGroupId = $('#favGroupId').val() || null;
            const $select = $('#select_group');

            $('#checked_stock_count').html(getCheckedMainStockCount());

            // 空文字をnullに変換
            const validGroupId = favGroupId !== '' ? favGroupId : null;
            $select.html('<option>読み込み中...</option>');
            // グループの登録有無を確認
            // お気に入りに登録しているグループ毎の銘柄数を取得
            $.ajax({
                url: $('#routeAjaxUserReportCount').val(),
                type: 'POST',
                data: {
                    group_id: validGroupId,
                }
            }).done(function (response) {
                $select.empty();

                if (response === null) {
                    lib.jqAlert('お気に入りへ登録', 'お気に入り銘柄を登録するためには、お気に入りグループの登録を行ってください。');
                    return;
                }

                $.each(response, function (index, val) {
                    $select.append(`<option value="${index}">${val.name}（${val.count}/50件）</option>`);
                });

                showSaveFavModal();
                addFavCheckedStock();

                $('#favorite_count').attr('data-favorite_count', JSON.stringify(response));
            }).fail(function (xhr, status, error) {
                lib.jqAlert('お気に入り / 損益シミュレータへ登録', 'エラーが発生しました。');
            });
        }
    });

    // ボタンクリック:損益シミュレータに登録サブモーダル表示
    $('#modal_save_stock_main #reg_sim').on('click', () => {
        // チェックされた銘柄があるか確認
        if (getCheckedMainStockCount() <= 0) {
            lib.jqAlert('お気に入り / 損益シミュレータへ登録', '登録する銘柄を選択してください。');
            return;
        }

        // 損益シミュレータに登録モーダル表示用情報取得
        $.ajax({
            url: $('#routeAjaxGetSimModalInfo').val(),
            type: 'POST',
            success: function (response) {
                // 登録されている銘柄件数 + チェックされた銘柄件数が200件より多ければアラートを出す
                const simulatorMaxCount = $('#simulator_max_length').val();
                if ((response.count + $('#modal_save_stock_main tbody input[type="checkbox"]:checked').length) > simulatorMaxCount) {
                    lib.jqAlert('お気に入り / 損益シミュレータへ登録', '損益シミュレータに登録できる上限を越えています。（最大：' + simulatorMaxCount + '件、' + response.count + '件登録済）');
                } else {
                    // モーダル表示内テーブル生成
                    addSimulatorCheckedStock(response.rate);
                    showSaveSimModal();
                    // 入力チェック（行を生成下あとに呼び出さないと要素を読み取れない）
                    settingUpdate.settingUpdateValide();
                }
            },
            error: function (xhr, status, error) {
                lib.jqAlert('お気に入り / 損益シミュレータへ登録', 'エラーが発生しました。');
            }
        });
    });

    // メイン：「キャンセル」ボタンクリック
    $('#modal_save_stock_main #cancel').on('click', () => {
        hideSaveStockModal();
    });

    // メイン：「×」ボタンクリック
    $('#modal_save_stock_main .close_button').on('click', () => {
        hideSaveStockModal();
    });

    // サブ お気に入り：「キャンセル」ボタンクリック
    $('#modal_save_stock_fav #cancel').on('click', () => {
        hideSaveFavModal();
    });

    // サブ お気に入り：「×」ボタンクリック
    $('#modal_save_stock_fav .close_button').on('click', () => {
        hideSaveFavModal();
    });

    // サブ 損益：「キャンセル」ボタンクリック
    $('#modal_save_stock_sim #cancel').on('click', () => {
        hideSaveSimModal();
    });

    // サブ 損益：「×」ボタンクリック
    $('#modal_save_stock_sim .close_button').on('click', () => {
        hideSaveSimModal();
    });

    // メインモーダル表示
    const showSaveStockModal = () => {
        // オーバレイ表示
        showSaveStock1stOverlay();
        // モーダル表示
        $('#modal_save_stock_main').show();
    };

    // メイン オーバレイ表示
    const showSaveStock1stOverlay = (animationSpeed = 'fast') => {
        $('body').append('<div id="modal_save_stock_main_overlay"></div>');
        $('#modal_save_stock_main_overlay').slideDown(animationSpeed);
        $('#modal_save_stock_main_overlay').on('click', () => {
            hideSaveStockModal();
        });
    };

    // メインモーダル非表示
    const hideSaveStockModal = () => {
        $('#modal_save_stock_main').hide();
        hideSaveStock1stOverlay();
        // モーダルの行を空にする
        $('#modal_save_stock_main tbody').empty();
    };

    // メイン オーバレイ非表示
    const hideSaveStock1stOverlay = (animationSpeed = 'fast') => {
        $('#modal_save_stock_main_overlay').slideUp(
            animationSpeed,
            function () {
                $('#modal_save_stock_main_overlay').remove();
            }
        );
    };

    // サブ お気に入り モーダル表示
    const showSaveFavModal = () => {
        // オーバレイ表示
        showSaveStock2ndOverlay();
        // モーダル表示
        $('#modal_save_stock_fav').show();
    };

    // サブ 損益 モーダル表示
    const showSaveSimModal = () => {
        // オーバレイ表示
        showSaveStock2ndOverlay();
        // モーダル表示
        $('#modal_save_stock_sim').show();
    };

    // お気に入り オーバレイ表示
    const showSaveStock2ndOverlay = (animationSpeed = 'fast') => {
        $('body').append('<div id="modal_save_stock_sub_overlay"></div>');
        $('#modal_save_stock_sub_overlay').slideDown(animationSpeed);
        $('#modal_save_stock_sub_overlay').on('click', () => {
            hideSaveFavModal();
            hideSaveSimModal();
        });
    };

    // サブ お気に入り モーダル非表示
    const hideSaveFavModal = () => {
        $('#modal_save_stock_fav').hide();
        hideSaveStockSubOverlay();
    };

    // サブ 損益 モーダル非表示
    const hideSaveSimModal = () => {
        $('#modal_save_stock_sim').hide();
        hideSaveStockSubOverlay();
    };

    // サブ オーバレイ非表示
    const hideSaveStockSubOverlay = (animationSpeed = 'fast') => {
        $('#modal_save_stock_sub_overlay').slideUp(
            animationSpeed,
            function () {
                $('#modal_save_stock_sub_overlay').remove();
            }
        );
    };

    // チェックされた銘柄を取得しセット(スクリーニングと決算カレンダーのみ)
    const updateAddFavSimShareClassIds = () => {
        const checkedStocks = [];

        $('#screening_result_table tbody input[type="checkbox"]:checked, #schedule_detail tbody input[type="checkbox"]:checked').each(function () {
            let row = $(this).closest('tr');
            let stock = {
                NAME_DISP: row.find('.stock_name a').attr('title') || row.find('.stock_name a').text().trim(),
                SYMBOL: row.find('.symbol').text().trim(),
                EXCHANGE_NAME_DISP: row.find('.market').text().trim(),
                SHARECLASS_ID: $(this).val()
            };
            checkedStocks.push(stock);
        });

        // JSON形式にしてhiddenフィールドにセット
        $('#addFavSimShareClassIds').val(JSON.stringify(checkedStocks));
    };

    // チェックされた銘柄を取得しセット(個別銘柄)
    const updateSymbolDetailFavSimShareClassId = () => {
        const checkedStocks = $('#report_header').map(function () {
            return {
                NAME_DISP: $(this).find('.stock_name').attr('title') || $(this).find('.stock_name').text().trim(),
                SYMBOL: $(this).find('.ticker').text().trim(),
                EXCHANGE_NAME_DISP: $(this).find('.exchange').text().trim(),
                SHARECLASS_ID: $('body #shareClassId').val()
            };
        }).get();

        // JSON形式に変換してhiddenフィールドにセット
        $('#addFavSimShareClassIds').val(JSON.stringify(checkedStocks));
    };

    // 登録メインモーダルにチェック済み、もしくは現在表示されている銘柄を追加
    const addMainModalList = (shareClassIds) => {
        const $tbody = $('#modal_save_stock_main tbody');

        // 一度内容をクリア
        $tbody.empty();

        if (shareClassIds.length === 0) {
            $tbody.append(`
                <tr>
                    <td colspan="2" class="no-stock">該当銘柄なし</td>
                </tr>
            `);
            return;
        }

        $.each(shareClassIds, function (index, stock) {
            const id = stock.SHARECLASS_ID;
            const nameDisp = stock.NAME_DISP;
            const symbol = stock.SYMBOL;
            const market = stock.EXCHANGE_NAME_DISP;

            const newRow = `
                <tr>
                    <td class="stock">
                        <div class="stock_name" data-stock_name="${nameDisp}" title="${nameDisp}">
                            <span>${nameDisp}</span>
                        </div>
                        <div>
                            <span class="symbol">${symbol}&nbsp;</span>
                            <span class="market">${market}</span>
                        </div>
                    </td>
                    <td class="register add_favorite">
                        <input type="checkbox" name="shareClassId" value="${id}" class="modal_check" checked>
                    </td>
                </tr>
            `;

            // 新しい行をtbodyに追加
            $tbody.append(newRow);
        });
    }

    // サブ お気に入りに登録モーダルにチェック済みの銘柄を追加
    const addFavCheckedStock = () => {
        let $favoriteList = $('#favorite_list tbody');
        $favoriteList.empty();

        // チェックされた銘柄を取得
        const $checkedStocks = $('.add_favorite input[type="checkbox"]:checked');

        // チェックされた銘柄を追加
        $checkedStocks.each(function () {
            let row = $(this).closest('tr');
            let name = row.find('.stock_name').data('stock_name');
            let symbol = row.find('.symbol').text().trim();
            let market = row.find('.market').text().trim();
            let shareClassId = $(this).val();

            // tbodyに行を追加
            $favoriteList.append(`
                <tr data-shareclass-id="${shareClassId}">
                    <td class="stock">
                        <div class="stock_name" title="${name}">
                            <span>${name}</span>
                        </div>
                        <div>
                            <span class="symbol">${symbol}&nbsp;</span>
                            <span class="market">${market}</span>
                        </div>
                    </td>
                </tr>
            `);
        });
    };

    // メイン→お気に入り/損益シミュレータ チェックされた銘柄があるか確認
    const getCheckedMainStockCount = () => {
        return $('#modal_save_stock_main tbody input[type="checkbox"]:checked').length;
    };

    // チェックされた銘柄を選択したグループに登録処理
    const registerStocksToFavGroup = () => {
        // 選択中のグループIDを取得
        const favGroupId = $('#select_group').val();
        if (! favGroupId) {
            lib.jqAlert('お気に入りへ登録', '選択した銘柄を登録するグループを選択してください。');
            return;
        }

        // チェックされている銘柄情報を取得
        const favStocks = [];
        $('#modal_save_stock_fav tbody tr').each(function () {
            const $row = $(this);
            favStocks.push({
                SHARECLASS_ID: $row.data('shareclass-id'),
            });
        });

        // オブジェクト形式から配列に変換
        let shareClassIds = favStocks.map(stock => stock.SHARECLASS_ID);

        if (favStocks.length === 0) {
            lib.jqAlert('お気に入りへ登録', 'お気に入りグループへ登録する銘柄を選択してください。');
            return;
        }

        // 選択されているグループに銘柄を登録
        lib.showLoadingOverlay();
        registerFavAjax(shareClassIds,favGroupId);
    };

    // 重複処理を含むお気に入り登録ajax
    const registerFavAjax = (shareClassIds, favGroupId) => {
        $.ajax({
            url: $('#routeAjaxAddFavorite').val(),
            type: 'POST',
            dataType: 'json',
            data: {
                shareClassIds: shareClassIds,
                favGroupId: favGroupId,
            }
        })
        .done(function (response) {
            const url = new URL(window.location.href);

            // 重複あり
            if (response.duplicateFlg === 1) {
                lib.removeLoadingOverlay();
                const names = response.duplicateStockInfo.map(stock => ' - ' + stock.NAME_DISP).join('<br>');
                const duplicateIds = response.duplicateStockInfo.map(stock => stock.SHARECLASS_ID);
                const filteredshareClassIds = shareClassIds.filter(id => ! duplicateIds.includes(id));

                // 全部重複している場合
                if (filteredshareClassIds.length === 0) {
                    lib.jqAlert('お気に入りへ登録', '以下の銘柄はすでに登録されています：<br>' + names);
                    return;
                }

                // 一部のみ重複している場合
                lib.jqConfirm(
                    'お気に入りへ登録',
                    '以下の銘柄はすでに登録されています：<br>' + names + '<br><br>重複していない銘柄のみを登録しますか？',
                    function () {
                        lib.showLoadingOverlay();

                        // 再帰的に呼び出す
                        registerFavAjax(filteredshareClassIds, favGroupId);
                    }
                );
                return;
            }

            // 上限オーバー
            if (response.overFlg === 1) {
                lib.removeLoadingOverlay();
                const count = $('#favorite_count').data('favorite_count')[favGroupId]['count'];
                lib.jqAlert('お気に入りへ登録', '1グループに登録できる銘柄数の上限を越えています。（最大：50件、' + count + '件登録済）');
                return;
            }

            // 正常登録
            if (url.pathname.includes('/favorite/')) {
                url.searchParams.set('favGroupId', favGroupId);
                location.href = url.toString();
            } else {
                location.reload();
            }
        })
        .fail(function () {
            lib.jqAlert('お気に入りへ登録', 'エラーが発生しました。');
        });
    }

    // サブ お気に入り「保存して閉じる」ボタン
    $('#sub_reg_fav').on('click', registerStocksToFavGroup);

    // 損益シミュレータに登録モーダル表示銘柄情報生成
    const addSimulatorCheckedStock = (rate) => {
        let $simulatorList = $('#simulator_list tbody');
        $simulatorList.empty();

        // チェックされた銘柄を取得
        const $checkedStocks = $('.add_favorite input[type="checkbox"]:checked');

        // チェックされた銘柄を追加
        $checkedStocks.each(function () {
            let row = $(this).closest('tr');
            let name = row.find('.stock_name').data('stock_name');
            let symbol = row.find('.symbol').text().trim();
            let market = row.find('.market').text().trim();
            let shareClassId = $(this).val();
            let Year = new Date().getFullYear();
            let Month = new Date().getMonth() + 1;
            let Day = new Date().getDate();
            let defaultDate = Year + '/' + Month.toString().padStart(2, 0) + '/' + Day.toString().padStart(2, 0);

            // tbodyに行を追加
            $simulatorList.append(`
                <tr>
                    <td id="left">
                        <div class="stock_name">
                            <span class="disp_common_stock_name" title="${name}">${name}</span>
                        </div>
                        <div><span class="symbol">${symbol}&nbsp;</span><span class="market">
                            ${market}</span></div>
                        <input type="hidden" name="su_shareclass_id[]" value="${shareClassId}">
                    </td>
                    <td id="center">
                        <input type="text" id="report_count" class="su_stock_number set_sim" name="su_stock_number[]" placeholder="123456" required maxlength="9" pattern="^([0-9]{0,6}|0)(\\.[0-9]{1,2})?$">
                    </td>
                    <td id="center">
                        <input type="text" id="report_price" class="su_unit_price set_sim" name="su_unit_price[]" placeholder="1234.56" required maxlength="7" pattern="^([0-9]{0,4}|0)(\\.[0-9]{1,2})?$">
                    </td>
                    <td id="center">
                        <input type="text" id="report_rate" class="su_setting_rate set_sim" value="${rate}" name="su_setting_rate[]" required maxlength="6" pattern="^([0-9]{0,3}|0)(\\.[0-9]{1,2})?$">
                    </td>
                    <td id="center">
                        <input type="text" id="report_get_date" class="su_acquisition_date set_sim" name="su_acquisition_date[]" value="${defaultDate}" required maxlength="10">
                    </td>
                </tr>
            `);
        });
    }

    // 損益シミュレータに登録：「登録」ボタンクリック
    $('#modal_save_stock_sim #reg_sim').on('click', () => {
        let insertSimulatorCommonUrl = $('#routeAjaxInsertSimulatorCommon').val();
        let result;

        result = settingUpdate.settingUpdateButtonClickValide();

        if (result === true) {
            // 二重クリック防止
            lib.showLoadingOverlay();

            let shareclass_id = [];
            $('input[name="su_shareclass_id[]"]').each(function (index, value) {
                shareclass_id.push($(value).val());
            });
            let stock_number = [];
            $('input[name="su_stock_number[]"]').each(function (index, value) {
                stock_number.push($(value).val());
            });
            let unit_price = [];
            $('input[name="su_unit_price[]"]').each(function (index, value) {
                unit_price.push($(value).val());
            });
            let setting_rate = [];
            $('input[name="su_setting_rate[]"]').each(function (index, value) {
                setting_rate.push($(value).val());
            });
            let acquisition_date = [];
            $('input[name="su_acquisition_date[]"]').each(function (index, value) {
                acquisition_date.push($(value).val());
            });

            lib.showLoadingOverlay();
            $.ajax({
                url: insertSimulatorCommonUrl,
                type: 'POST',
                data: {
                    'su_shareclass_id': shareclass_id,
                    'su_stock_number': stock_number,
                    'su_unit_price': unit_price,
                    'su_setting_rate': setting_rate,
                    'su_acquisition_date': acquisition_date,
                },
                success: function (response) {
                    location.reload();
                },
                error: function (xhr, status, error) {
                    lib.removeLoadingOverlay();
                    lib.jqAlert('損益シミュレータ', 'エラーが発生しました。');
                }
            });
        }
    });

    // スクリーニングと決算カレンダーでチェックした状態での画面遷移時の警告
    // チェックボックスが1つでもチェックされているか判定
    // 登録処理が実行される際には実行しない
    let isSubmitting = false;

    // 登録ボタンが押されたらフラグを立てる（#registerBtn は実際のボタンのIDに変更してください）
    $(document).on('click', '#sub_reg_fav, #modal_save_stock_sim #reg_sim', function () {
        isSubmitting = true;
    });

    $(window).on('beforeunload', function (event) {
        // 登録処理であれば実行しない
        if (isSubmitting) {
            return;
        }

        if (
            $('#screening_result_table .register input[type="checkbox"]:checked').length > 0 ||
            $('#schedule_detail .register input[type="checkbox"]:checked').length > 0
        ) {
            event.preventDefault();
            event.returnValue = ''; // これが必要（互換性のため）
        }
    });

    // 損益シミュレータ登録の半角変換処理
    let isComposing = false;

    // IME入力開始／終了
    $(document)
        .on('compositionstart', '.set_sim', function() {
            isComposing = true;
        })
        .on('compositionend', '.set_sim', function() {
            isComposing = false;
            $(this).trigger('input'); // 確定後に再変換
    })
    .on('input', '.set_sim', function() {
        if (isComposing) return;

        let $input = $(this);
        let val = $input.val();

        // 全角を半角に変換
        val = val.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
                .replace(/．/g, '.')
                .replace(/[／⁄]/g, '/');

        // 取得日
        if ($input.hasClass('su_acquisition_date') || $input.hasClass('acquisition_date')) {
            // 数字とスラッシュ以外を削除
            val = val.replace(/[^0-9/]/g, '');
        // 取得日以外
        } else {
            // 数字と小数点以外を削除
            val = val.replace(/[^0-9.]/g, '');
        }

        $input.val(val);
    });
});
